export const ATTENDANT_PHOTO_MAX_BYTES = 512 * 1024;
export const ATTENDANT_PHOTO_MAX_DIMENSION = 512;

const OUTPUT_TYPE = 'image/jpeg';
const QUALITY_STEPS = [0.82, 0.74, 0.66, 0.58, 0.5];

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Não foi possível ler a imagem.'));
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Não foi possível processar essa imagem.'));
    image.src = src;
  });
}

function canvasToBlob(canvas, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
          return;
        }
        reject(new Error('Não foi possível compactar essa imagem.'));
      },
      OUTPUT_TYPE,
      quality
    );
  });
}

function blobToDataUrl(blob) {
  return readFileAsDataUrl(blob);
}

export async function prepareAttendantPhoto(file) {
  if (!file || !file.type?.startsWith('image/')) {
    throw new Error('Selecione um arquivo de imagem válido.');
  }

  const originalDataUrl = await readFileAsDataUrl(file);
  const image = await loadImage(originalDataUrl);
  const sourceWidth = image.naturalWidth || image.width;
  const sourceHeight = image.naturalHeight || image.height;

  if (!sourceWidth || !sourceHeight) {
    throw new Error('Não foi possível identificar as dimensões da imagem.');
  }

  const scale = Math.min(
    1,
    ATTENDANT_PHOTO_MAX_DIMENSION / Math.max(sourceWidth, sourceHeight)
  );
  const width = Math.max(1, Math.round(sourceWidth * scale));
  const height = Math.max(1, Math.round(sourceHeight * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d', { alpha: false });
  if (!context) {
    throw new Error('Não foi possível preparar a imagem neste navegador.');
  }

  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, width, height);
  context.drawImage(image, 0, 0, width, height);

  let bestBlob = null;
  for (const quality of QUALITY_STEPS) {
    const blob = await canvasToBlob(canvas, quality);
    bestBlob = blob;
    if (blob.size <= ATTENDANT_PHOTO_MAX_BYTES) {
      const dataUrl = await blobToDataUrl(blob);
      return {
        dataUrl,
        previewUrl: URL.createObjectURL(blob),
      };
    }
  }

  if (bestBlob && bestBlob.size <= ATTENDANT_PHOTO_MAX_BYTES) {
    const dataUrl = await blobToDataUrl(bestBlob);
    return {
      dataUrl,
      previewUrl: URL.createObjectURL(bestBlob),
    };
  }

  throw new Error('A foto continua muito grande após a compactação. Tente outra imagem.');
}
